import { BaseSettings } from "./base";
import { storage } from "../storage/storage.js"
import * as LOG from "../log";
import { AppRegistry } from "../apps"
import { cloneObject } from "../util/index.js";

export const SCREEN_SIZES = {
  SS_DEFAULT: "default",
  SS_NATIVE: "native",
  SS_16_9: "16:9",
  SS_FILL: "fill"
}

export class Settings extends BaseSettings {
  constructor(storage) {
    super(storage);
    this.vsync = true;
    this.bilinearFilter = false;
    this.cloudStorage = false;
    this.hideTitleBar = false;
    this.disableGameSavesAfterState = false;
    this.dbToken = null;
    this.raEnabled = false;
    this.raToken = null;
    this.raUsername = null;
    this.screenSize = SCREEN_SIZES.SS_NATIVE;
    this.hideVersion = "";
    this.overrides = {};
  }

  PREFIX = "wrcSettings.";
  VSYNC_PROP = this.PREFIX + "vsync";
  BILINEAR_FILTER_PROP = this.PREFIX + "bilinearFilter";
  SCREEN_SIZE_PROP = this.PREFIX + "screenSize";
  CLOUD_STORAGE_PROP = this.PREFIX + "cloudStorage";
  HIDE_TITLE_BAR_PROP = this.PREFIX + "hideTitleBar";
  DB_TOKEN = this.PREFIX + "dbToken";
  RA_ENABLED = this.PREFIX + "raEnabled";
  RA_TOKEN = this.PREFIX + "raToken";
  RA_USERNAME = this.PREFIX + "raUsername";
  OVERRIDES = this.PREFIX + "overrides";
  HIDE_VERSION = this.PREFIX + "hideVersion";
  DISABLE_GAME_SAVES_AFTER_STATE = this.PREFIX + "disableGameSavesAfterState"

  VERSION = "0.2.4";

  async load() {
    LOG.info("Loading settings.");
    this.vsync = await this.loadBool(this.VSYNC_PROP, this.vsync);
    this.cloudStorage = await this.loadBool(this.CLOUD_STORAGE_PROP, this.cloudStorage);
    this.bilinearFilter = await this.loadBool(this.BILINEAR_FILTER_PROP, this.bilinearFilter);
    this.hideTitleBar = await this.loadBool(this.HIDE_TITLE_BAR_PROP, this.hideTitleBar);
    this.dbToken = await this.loadValue(this.DB_TOKEN, this.dbToken);
    this.raEnabled = await this.loadBool(this.RA_ENABLED, this.raEnabled);
    this.raToken = await this.loadValue(this.RA_TOKEN, this.raToken);
    this.raUsername = await this.loadValue(this.RA_USERNAME, this.raUsername);
    this.screenSize = await this.loadValue(this.SCREEN_SIZE_PROP, this.screenSize);
    this.overrides = await this.loadValue(this.OVERRIDES, this.overrides);
    this.hideVersion = await this.loadValue(this.HIDE_VERSION, "");
    this.disableGameSavesAfterState = await this.loadValue(this.DISABLE_GAME_SAVES_AFTER_STATE, this.disableGameSavesAfterState);

    // this.cloudStorage = true;
    // this.dbToken = "vaoZQfPiTCYAAAAAAAAAATolyz_w30Rse94rmLBbQ15MxOmKvTQ_Vgkzehdf4NsQ";

    // this.cloudStorage = true;
    // this.dbToken = "vaoZQfPiTCYAAAAAAAAAATolyz_w30Rse94rmLBbQ15MxOmKvTQ_Vgkzehdf4NsQ";

    // this.dbToken = "0vyinWNqmxMAAAAAAAAAAROzrqT2IoTqw4xWdsVQRdu1MShAiE3_0qRJ58DjuFD1";
    // // this.bilinearFilter = true;
    //  this.disableGameSavesAfterState = true;

    // this.raEnabled = true;
    // this.raUsername = "raz0red";
    // this.raToken = "BqD7eoWg2lki91cB";

    console.log(this.overrides)
  }

  async save() {
    LOG.info("Saving settings.");
    await this.saveBool(this.VSYNC_PROP, this.vsync);
    await this.saveBool(this.CLOUD_STORAGE_PROP, this.cloudStorage);
    await this.saveBool(this.BILINEAR_FILTER_PROP, this.bilinearFilter);
    await this.saveBool(this.HIDE_TITLE_BAR_PROP, this.hideTitleBar);
    await this.saveValue(this.DB_TOKEN, this.dbToken);
    await this.saveBool(this.RA_ENABLED, this.raEnabled);
    await this.saveValue(this.RA_TOKEN, this.raToken);
    await this.saveValue(this.RA_USERNAME, this.raUsername);
    await this.saveValue(this.SCREEN_SIZE_PROP, this.screenSize);
    await this.saveValue(this.DISABLE_GAME_SAVES_AFTER_STATE, this.disableGameSavesAfterState);
    await this.saveValue(this.OVERRIDES, this.overrides);
    await this.saveValue(this.HIDE_VERSION, this.hideVersion);
  }

  getDbToken() {
    return this.dbToken;
  }

  setDbToken(t) {
    this.dbToken = t;
  }

  isRaEnabled() {
    return this.raEnabled;
  }

  setRaEnabled(b) {
    this.raEnabled = b;
  }

  getRaToken() {
    return this.raToken;
  }

  setRaToken(t) {
    this.raToken = t;
  }

  getRaUsername() {
    return this.raUsername;
  }

  setRaUsername(u) {
    this.raUsername = u;
  }

  isCloudStorageEnabled() {
    return this.cloudStorage;
  }

  setCloudStorageEnabled(b) {
    this.cloudStorage = b;
  }

  isVsyncEnabled() {
    return this.vsync;
  }

  setVsyncEnabled(b) {
    this.vsync = b;
  }

  isBilinearFilterEnabled() {
    return this.bilinearFilter;
  }

  setBilinearFilterEnabled(b) {
    this.bilinearFilter = b;
  }

  getHideTitleBar() {
    return this.hideTitleBar;
  }

  setHideTitleBar(b) {
    this.hideTitleBar = b;
  }

  getScreenSize() {
    return this.screenSize;
  }

  setScreenSize(s) {
    this.screenSize = s;
  }

  getOverrides() {
    return cloneObject(this.overrides);
  }

  setOverrides(s) {
    this.overrides = s;
  }

  isGameSavesDisabledAfterState() {
    return this.disableGameSavesAfterState;
  }

  setGameSavesDisabledAfterState(b) {
    this.disableGameSavesAfterState = b;
  }

  setHideVersionInfo() {
    this.hideVersion = this.VERSION;
  }

  getHideVersionInfo() {
    return this.hideVersion === this.VERSION;
  }
}

const settings = new Settings(storage);
AppRegistry.instance.setSettings(settings);
export { settings };
